import { Checkbox, FormControlLabel, Link, Typography } from "@mui/material";

import {
  useConfgOrganizationDownloadTerms,
  useConfgTerms,
} from "../../hooks/confg/base";

const TermsAndConditions = (props: {
  type: "platform" | "custom";
  agreed: boolean;
  handleAgreed: (e: any) => void;
}) => {
  const custom = useConfgOrganizationDownloadTerms();
  const platform = useConfgTerms();

  const handleDownload = () => {
    props.type === "platform" ? platform.mutate({}) : custom.mutate({});
  };

  return (
    <div>
      <FormControlLabel
        control={
          <Checkbox
            name="termsAgreement"
            color="primary"
            checked={props.agreed}
            onChange={props.handleAgreed}
          />
        }
        label={
          <Typography variant="body2" align="center">
            I agree to the{" "}
            <Link color="secondary" onClick={handleDownload} underline="none">
              Terms & Conditions
            </Link>
          </Typography>
        }
      />
    </div>
  );
};

export default TermsAndConditions;
